export default {
  label: 'Chatea con nuestro equipo',
  label_unread: 'Chatea con nuestro equipo, {{count}} nuevos',
};
